module.exports = __webpack_public_path__ + "media/packs/fonts/IsidoraSans-SemiBold-040fb916284ecbf798c83e2dcaca636f.woff2";